(function ($) {
  'use strict';

  const QuizApp = {
    currentQuestion: 1,
    totalQuestions: 7,
    answers: {},

    init() {
      this.bindEvents();
      this.updateProgress();
      this.updateNavigation();
    },

    bindEvents() {
      const self = this;

      $('.quiz-option').on('click', function () {
        const $btn = $(this);
        const $question = $btn.closest('.quiz-question');
        const prefix = $question.data('tag-prefix');
        const value = $btn.data('value');

        self.answers[prefix] = value;
        $question.find('.quiz-option').removeClass('selected');
        $btn.addClass('selected');

        setTimeout(() => self.nextQuestion(), 200);
      });

      $('#backBtn').on('click', () => this.prevQuestion());
      $('#retakeBtn').on('click', () => this.resetQuiz());

      $('.filter-btn').on('click', function () {
        $('.filter-btn').removeClass('active');
        $(this).addClass('active');
        self.sortResults($(this).data('sort'));
      });
    },

    nextQuestion() {
      const $current = $('.quiz-question[data-question="' + this.currentQuestion + '"]');

      if (this.currentQuestion < this.totalQuestions) {
        $current.hide().removeClass('active');
        this.currentQuestion++;
        $('.quiz-question[data-question="' + this.currentQuestion + '"]')
          .fadeIn(200)
          .addClass('active');
        this.updateProgress();
        this.updateNavigation();
      } else {
        this.fetchResults();
      }
    },

    prevQuestion() {
      if (this.currentQuestion === 1) return;
      const $current = $('.quiz-question[data-question="' + this.currentQuestion + '"]');
      $current.hide().removeClass('active');
      this.currentQuestion--;
      $('.quiz-question[data-question="' + this.currentQuestion + '"]')
        .fadeIn(200)
        .addClass('active');
      this.updateProgress();
      this.updateNavigation();
    },

    /* ✅ FIXED FUNCTION */
    fetchResults() {
      const self = this;

      $('.quiz-container, .quiz-navigation').hide();
      $('#quizLoading').fadeIn(200);

      const tags = [];

      $.each(this.answers, function (prefix, value) {
        if (value !== 'skip' && value !== 'all' && value !== 'other') {
          tags.push(prefix + '-' + value);
        }
      });

      // Build proper Shopify search query
      const tagQuery = tags.map(tag => 'tag:' + tag).join(' AND ');
      const url = '/search?q=' + encodeURIComponent(tagQuery) + '&type=product&view=ajax';

      $.getJSON(url, function (products) {
        self.displayResults(products);
      }).fail(function () {
        $('#quizLoading').hide();
        $('#quizResults').fadeIn(200);
        $('#resultsCount').text(0);
        $('#resultsSummary').html(self.buildSummary());
        $('#resultsGrid').html('<p class="no-results">No shoes match your preferences. Try adjusting your selections.</p>');
      });
    },

    displayResults(products) {
      $('#quizLoading').hide();
      $('#quizResults').fadeIn(200);
      $('#resultsCount').text(products.length);
      $('#resultsSummary').html(this.buildSummary());

      if (!products.length) {
        $('#resultsGrid').html('<p class="no-results">No matches found.</p>');
        return;
      }

      this.renderProducts(products);
    },

    renderProducts(products) {
      const self = this;
      let html = '';

      products.forEach(function (product) {
        html += `
          <div class="result-product" data-price="${product.price}">
            <a href="${product.url}">
                <div class="search_product_info">
              <img src="${product.featured_image}" alt="${product.title}">
              <h3>${product.title}</h3>
              <p>${self.formatPrice(product.price)}</p>
              </div>
            </a>
            <button class="product-add-to-cart" data-id="${product.id}">
              Add to Cart
            </button>
          </div>
        `;
      });

      $('#resultsGrid').html(html);
      this.bindAddToCart();
    },

    bindAddToCart() {
      $('.product-add-to-cart').on('click', function () {
        const id = $(this).data('id');
        $.post('/cart/add.js', { id, quantity: 1 })
          .done(() => alert('Added to cart!'))
          .fail(() => alert('Error adding to cart'));
      });
    },

    formatPrice(p) {
      return '₹' + (p / 100).toFixed(2);
    },

    sortResults(type) {
      const $items = $('#resultsGrid .result-product');

        const sorted = $items.sort(function (a, b) {
            const priceA = +$(a).data('price');
            const priceB = +$(b).data('price');

            if (type === 'price-low') return priceA - priceB;
            if (type === 'price-high') return priceB - priceA;

            return 0;
        });

      $('#resultsGrid').html(sorted);
    },

    buildSummary() {
      const parts = [];
      if (this.answers.gender) parts.push(this.answers.gender);
      if (this.answers.brand) parts.push(this.answers.brand);
      if (this.answers.style) parts.push(this.answers.style);
      if (this.answers.color) parts.push(this.answers.color);
      return 'Based on: <strong>' + parts.join(', ') + '</strong>';
    },

    updateProgress() {
      $('#progressBar').css('width', (this.currentQuestion / this.totalQuestions) * 100 + '%');
      $('#currentQuestion').text(this.currentQuestion);
    },

    updateNavigation() {
      $('#backBtn').toggle(this.currentQuestion > 1);
    },

    resetQuiz() {
      location.reload();
    }
  };

  $(document).ready(() => QuizApp.init());

})(jQuery);
